import moment from 'moment';
import { DEFAULT_INCLUSIVITY } from '../constants/datetime';
import {
    SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE,
    SCHEDULE_SESSION_DISPLAY_TYPE_ROUND,
} from 'common-data-handling';

/**
 * Checks if a program session is in the future
 * @param {object} session     Event program item
 * @param {number} beforeStart Only sessions starting in less than this
 * @param {number} afterStart  Limit after start will not be considered
 * @param {number} unit        Unit to be applied to tolerance value
 * @returns boolean
 */
export function isUpcomingSession(
    session,
    beforeStart = 0,
    afterStart = 0,
    unit = 'minutes'
) {
    let start = beforeStart
            ? moment(session.start_local ?? session.start_utc).subtract(
                  beforeStart,
                  unit
              )
            : moment(),
        end = moment(session.start_local ?? session.start_utc).add(
            afterStart,
            unit
        );
    return (
        moment().isBefore(session.end_local ?? session.end_utc) &&
        moment().isBetween(start, end, null, DEFAULT_INCLUSIVITY)
    );
}

/**
 * Returns true if the function should appear on networkarea
 * @param {object} session          Program item object
 * @param {array}  selectedSessions User schedule selections
 * @param {array}  all              The complete event program
 * @returns boolean
 *
 * You may want to use useIsValidWaitingRoomSessionFilter wrapped function instead of using this directly :)
 */
export function isValidWaitingRoomSession(
    session,
    selectedSessions = [],
    all = []
) {
    return (
        session &&
        [
            SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE,
            SCHEDULE_SESSION_DISPLAY_TYPE_ROUND,
        ].includes(session.display_type) &&
        (session.is_selected || !session.is_selectable) &&
        (session.show_waiting_room ||
            (session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ROUND &&
                !selectedSessions.find((s) => s.round_id == session.id) &&
                all.find(
                    (s) =>
                        s.round_id == session.id &&
                        s.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE
                ))) &&
        // since this is time related, maybe it should moved into a separated function
        moment().diff(session.start_utc, 'minutes') >
            -session.waiting_room_display_time
    );
}

/**
 * Returns true when the program item has external content to show
 * @param {object} session Program item object
 * @returns boolean
 */
export function isExternalContentAvailable(session) {
    let { start_utc, session_content_display_time } = session;

    return (
        moment(start_utc).diff(new Date(), 'minutes', true) <=
        session_content_display_time
    );
}

export { isSessionOverlaping } from 'common-data-handling';
export { isSessionAttendanceRequired } from 'common-data-handling';
export { isSessionAttendanceOptional } from 'common-data-handling';
